// @flow
import React, { type Element } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { pure } from 'recompose';
import classNames from 'classnames';
import { Track, analytics, urlCatalog } from 'angieslist-app-platform';
import menuAnalytics from './menuAnalytics';
import ProfileIndicator from './ProfileIndicator';
import profileSections from '../../common/profileSections';
import './Menu.scss';

export type Props = {
  serviceProviderId: string,
  currentPage: string,
  mobileUser: boolean,
};

const getDealsUrl = serviceProviderId => `${urlCatalog.officeRoot}/app/store/${serviceProviderId}/shop`;

export const MenuComponent = ({
  serviceProviderId, currentPage, mobileUser,
}: Props): Element<"div"> => (
  <div className="Edit-Profile--Menu-Component">
    <ul id="Edit-Profile--Menu-List" >
      <li>
        <div className="editProfileMenuListItemStyle" id="Contact-Information-div-parent">
          <div className="editProfileMenuListLinkItemStyle" >
            <Track>
              <Link
                id="Edit-Profile--MenuNav-Contact-Information"
                to={`/app/profile/${serviceProviderId}/contact-information`}
                activeClassName="active"
              >
                <span className="nav-item">Contact</span>
              </Link>
            </Track>
          </div>
          <ProfileIndicator sectionName={profileSections.CONTACT} />
        </div>
      </li>
      <li>
        <div className="editProfileMenuListItemStyle">
          <div className="editProfileMenuListLinkItemStyle">
            <Track>
              <Link
                id="Edit-Profile--MenuNav-About"
                to={`/app/profile/${serviceProviderId}/about`}
                activeClassName="active"
                className={classNames({ active: !currentPage && !mobileUser })}
              >
                <span className="nav-item">About</span>
              </Link>
            </Track>
          </div>
          <ProfileIndicator sectionName={profileSections.ABOUT} />
        </div>
      </li>
      <li>
        <div className="editProfileMenuListItemStyle">
          <div className="editProfileMenuListLinkItemStyle">
            <Track>
              <Link
                id="Edit-Profile--MenuNav-Hours"
                to={`/app/profile/${serviceProviderId}/hours`}
                activeClassName="active"
              >
                <span className="nav-item">Hours</span>
              </Link>
            </Track>
          </div>
          <ProfileIndicator sectionName={profileSections.HOURS} />
        </div>
      </li>
      <li>
        <div className="editProfileMenuListItemStyle">
          <div className="editProfileMenuListLinkItemStyle">
            <Track>
              <Link
                id="Edit-Profile--MenuNav-Service-Details"
                to={`/app/profile/${serviceProviderId}/service-details`}
                activeClassName="active"
              >
                <span className="nav-item">Service details</span>
              </Link>
            </Track>
          </div>
          <ProfileIndicator sectionName={profileSections.SERVICE_DETAILS} />
        </div>
      </li>
      <li>
        <div className="editProfileMenuListItemStyle">
          <div className="editProfileMenuListLinkItemStyle">
            <Track>
              <Link
                id="Edit-Profile--MenuNav-Project-Showcase"
                to={urlCatalog.office.spProfile.showcases(serviceProviderId)}
                activeClassName="active"
              >
                <span className="nav-item">Project showcase</span>
              </Link>
            </Track>
          </div>
          <ProfileIndicator sectionName={profileSections.SHOWCASE} />
        </div>
      </li>
      <li>
        <div className="editProfileMenuListItemStyle">
          <div className="editProfileMenuListLinkItemStyle">
            <Track>
              <a
                id="Edit-Profile--MenuNav-Photo-Gallery"
                href={urlCatalog.office.spProfile.images(serviceProviderId)}
              >
                <span className="nav-item">Photos </span>
              </a>
            </Track>
          </div>
          <ProfileIndicator sectionName={profileSections.PHOTOS} />
        </div>
      </li>
      <li>
        <div className="editProfileMenuListItemStyle">
          <div className="editProfileMenuListLinkItemStyle">
            <Track>
              <Link
                id="Edit-Profile--MenuNav-Licensing"
                to={`/app/profile/${serviceProviderId}/licensing`}
                activeClassName="active"
              >
                <span className="nav-item">Licensing & insurance</span>
              </Link>
            </Track>
          </div>
          <ProfileIndicator sectionName={profileSections.LICENSING} />
        </div>
      </li>
      <li>
        <a
          id="Edit-Profile--MenuNav-Deals"
          href={getDealsUrl(serviceProviderId)}
        >
          <span className="nav-item">Deals </span>
        </a>
      </li>
    </ul>
  </div>
);

export default (compose(
  analytics({ ruleset: menuAnalytics }),
  connect(state => ({
    serviceProviderId: state.serviceProviderId,
    serviceProviderProfile: state.serviceProviderProfile,
  })),
  pure,
)(MenuComponent): any);



// WEBPACK FOOTER //
// ./src/modules/profile/browser/components/Menu.js